<template>
  <div class="intro-block">
    <img
      class="footer-ohbot-logo"
      src="@/assets/beauty-logo.svg"
      alt="為美業打造的即時預約系統及經營管理工具。提供美業線上預約、會員經營、美業行銷、智能管店。專業服務交給您，其他給美業歐巴！"
    />
    <div class="intro-content">
      為美業打造的即時預約系統及經營管理工具。提供美業線上預約、會員經營、美業行銷、智能管店。專業服務交給您，其他給美業歐巴！
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="postcss">
.intro-block {
  @apply flex flex-col items-center;
  @apply <laptop: (items-start);
}
.intro-content {
  @apply text-[20px] leading-[32px] tracking-[2px] text-left mt-[24px] text-justify;
  @apply <laptop: (text-[14px] leading-[20.27px] mt-[8px] tracking-[1px]);
}

.footer-ohbot-logo {
  @apply laptop:(w-[219px] mx-auto);
  @apply <laptop: w-[138px] h-[41px];
}
</style>
